import { render, staticRenderFns } from "./StatisticPage1.vue?vue&type=template&id=6c70daa2&scoped=true"
import script from "./StatisticPage1.vue?vue&type=script&lang=js"
export * from "./StatisticPage1.vue?vue&type=script&lang=js"
import style0 from "./StatisticPage1.vue?vue&type=style&index=0&id=6c70daa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70daa2",
  null
  
)

export default component.exports